// service/agentApiSlice.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { keysToCamel } from '../../helpers/stringCaseTransform'
import { Agent } from '../model/agent.model'

// 🔥 Factory function — runtime baseApiUrl
export const createAgentApiSlice = (baseApiUrl: string) =>
  createApi({
    reducerPath: 'api/agents',
    baseQuery: fetchBaseQuery({
      baseUrl: baseApiUrl,
    }),
    endpoints: (builder) => ({
      getOneAgent: builder.query<Agent, { id: string }>({
        query: ({ id }) => ({
          url: `/agents/${id}`,
          headers: {
            'x-agent-id': id,
          },
        }),
        transformResponse: ({ agent }: { agent: Agent }) =>
          keysToCamel(agent),
      }),
    }),
  })
